<!-- <section class="breadcrumb-section">
  <div class="container">

    <nav aria-label="Breadcrumb">
      <ol class="breadcrumb-list">

        <li>
          <a routerLink="/">
            <i class="bi bi-house-door"></i>
            Home
          </a>
        </li>

        <li class="separator">
          <i class="bi bi-chevron-right"></i>
        </li>

        <li class="current-page" aria-current="page">
          {{ currentPage }}
        </li>

      </ol>
    </nav>

  </div>
</section> -->
<!-- <nav class="breadcrumb-container" aria-label="Breadcrumb">
  <a routerLink="/">Home</a>
  <span aria-hidden="true"> / </span>
  <span class="current-page">{{ currentPage }}</span>
</nav> -->
<nav class="mobile-breadcrumb" aria-label="Breadcrumb">
  <a routerLink="/">Home</a>

  <span class="separator">/</span>

  <span class="current-page">
    {{ currentPage }}
  </span>
</nav>